export default "__VITE_ASSET__22cb1911__"